import { render, staticRenderFns } from "./SmsOtp.vue?vue&type=template&id=6b33e5ce&"
import script from "./SmsOtp.vue?vue&type=script&lang=ts&"
export * from "./SmsOtp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports